'use client'

import { useScroll, m } from 'framer-motion'

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll()

  return (
    <m.div
      className="fixed top-0 left-0 right-0 h-0.5 bg-batman-gold z-[100] origin-left"
      style={{ scaleX: scrollYProgress }}
    />
  )
}
